import { forwardRef } from 'react';
import { Group } from 'three';

import PivotControls, { PivotControlsProps } from './PivotControls.js';

export type FurnitureControlsProps = PivotControlsProps & {};

export const FurnitureControls = forwardRef<Group, FurnitureControlsProps>(
  ({ ...restProps }, ref) => {
    return <PivotControls ref={ref} {...restProps} />;
  }
);

export default FurnitureControls;
